// Use this file to create and manage experiments on frontend side
// When you don't want to wait for the user-centric core config API response,
// you can define your experiments here
import md5 from 'crypto-js/md5';

import { CAR_RENTAL_ALLOWED_LOCALES, CAR_RENTAL_SEARCH_FORM_KEY } from '@constants/general';

const HEX_ARRAY = '0123456789ABCDEF'.split('');

// Converts bytes to a hexadecimal string
export const bytesToHex = (bytes: Uint8Array): string => {
  return Array.from(bytes)
    .map((byte) => {
      const v = byte & 0xff;
      return HEX_ARRAY[v >>> 4] + HEX_ARRAY[v & 0x0f];
    })
    .join('');
};

// Converts a hash to a percentage (1 - 100)
export const getExperimentPercentageValue = (clientId: string, salt?: string): number => {
  // Add optional salt to client ID
  const valueToHash = salt ? `${clientId}${salt}` : clientId;

  // Get MD5 hash as bytes
  const hashBytes = new Uint8Array(md5(valueToHash).words);

  // Convert bytes to hex string
  const hexString = bytesToHex(hashBytes);

  // Use first 8 chars of hex string to get percentage
  const hashNum = parseInt(hexString.substring(0, 8), 16);
  return (hashNum % 100) + 1;
};

export const getCarRentalSearchFormExperiment = (
  clientId: string,
  siteCode: string,
  locale: string,
): CoreConfig => {
  const percentageValue = getExperimentPercentageValue(clientId, 'WG-741-car-rental-search-form');
  // Exclude IN POS and non-en/ar locales and 40% of the users
  if (siteCode === 'IN' || !CAR_RENTAL_ALLOWED_LOCALES.includes(locale) || percentageValue <= 40) {
    return {
      key: CAR_RENTAL_SEARCH_FORM_KEY,
      value: '0',
      experimentName: '',
      variantName: '',
    };
  }
  // 40% exclude from the experiment
  // 30/30% split for the baseline and variant A

  const isVariantA = percentageValue > 70;

  return {
    key: CAR_RENTAL_SEARCH_FORM_KEY,
    value: isVariantA ? '1' : '0',
    experimentName: 'WG-741 car rental search form experiment',
    variantName: isVariantA ? 'Variant A' : 'Baseline',
  };
};

// Get all client side experiment core configs
export const getClientSideUserCentricConnect = (
  clientId: string,
  siteCode: string,
  locale: string,
): CoreConfig[] => {
  return [
    getCarRentalSearchFormExperiment(clientId, siteCode, locale),
    // Add other experiments here as needed
  ];
};
